module.exports = __webpack_public_path__ + "static/media/4hunger.c886221b.jpg";